import { Icon } from '@iconify/react';
import hashFill from '@iconify/icons-eva/hash-fill';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
// ----------------------------------------------------------------------

export const HandleMeasureIcon = (measure) => {
    if (measure.dataSetType === "MEASURE") {
        return <FunctionsOutlinedIcon className="cm_dimension_icon" />
    }
    else {
        switch (measure.type) {
            case 'time':
                return <DateRangeIcon className="cm_measr_lbl icon_color_main" />
            case 'number':
                return <Icon icon={hashFill} className="cm_measr_lbl num_icon " />
            default:
                return <LabelOutlinedIcon className="cm_measr_lbl" />

        }
    }
}

